import { secureGet, securePost } from "config/encryption_decryption/get_post_encryptDecrypt";

export const ReferalWalletBalance = async (panelListId) => {
  return secureGet("/api/survey/referralWallet", { panelListId });
};

export const JoinNowBonusBalanceApi = async (panelListId) => {
  return secureGet("/api/user/getBonusPoint", { panelListId });
};

export const GetBonusPointDetailsApi = async (panelListId, isAffiliatedUser, affiliateOfferId) => {
  return secureGet("/api/user/getBonusPointDetails", {
    panelListId,
    isAffiliatedUser,
    affiliateOfferId,
  });
};

export const getPointBalanceApi = async (panelListId) => {
  return secureGet("/api/user/GetPointBal", { panelListId });
};

export const getPointBalanceStudiesWiseApi = async (panelListId) => {
  return secureGet("/api/user/getPointBalanceStudiesWise", { panelListId });
};

export const StreakWalletBalanceApi = async (panelListId) => {
  return securePost("/api/survey/completeStatus", { panelListId });
};

/** ================== */
export const getUserWalletPointsApi = async (panelistId) => {
  return secureGet("/api/user/getUserWalletPoints", { panelistId });
};

export const getEnableUserForRedeemApi = async () => {
  return secureGet("/api/user/getEnableUserForRedeem", {});
};

export const checkUserGetActiveSubscriptionApi = async (panelListId) => {
  return secureGet("/api/user/checkUserGetActiveSubscriptionApi", { panelListId });
};

export const getCompleteCount = async (panelListId: number) => {
  return secureGet("/api/survey/getCompleteCount", { panelListId });
};
